import { closestCenter, DndContext, MouseSensor, TouchSensor, useSensor, useSensors, } from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import { SortableContext, verticalListSortingStrategy, } from '@dnd-kit/sortable';
import { CustomKeyboardSensor } from '@office-start/dnd-kit-utility';
import React from 'react';
import { DND_MINIMUM_ACTIVATION_DISTANCE_Y_AXIS_PX, DND_TOUCH_SENSOR_DELAY_MS, DND_TOUCH_SENSOR_TOLERANCE_PX, } from './Constants';
/**
 * Lazy loaded DnD Context.
 */
export var LazyDnDContext = function (_a) {
    var sortableItemsById = _a.sortableItemsById, children = _a.children, handleDragEndCallback = _a.handleDragEndCallback, handleDragStartCallback = _a.handleDragStartCallback, handleDragCancelCallback = _a.handleDragCancelCallback;
    var sensors = useSensors(useSensor(MouseSensor, {
        activationConstraint: {
            distance: { y: DND_MINIMUM_ACTIVATION_DISTANCE_Y_AXIS_PX },
        },
    }), useSensor(TouchSensor, {
        activationConstraint: {
            tolerance: DND_TOUCH_SENSOR_TOLERANCE_PX,
            // Use a delay of 250ms to account for some laptop touchpads with a 200ms to 220ms click latency.
            // The code example at https://docs.dndkit.com/api-documentation/sensors also uses 250ms.
            delay: DND_TOUCH_SENSOR_DELAY_MS,
        },
    }), useSensor(CustomKeyboardSensor));
    var handleDragEnd = React.useCallback(function (_event) {
        var active = _event.active, over = _event.over;
        if ((sortableItemsById === null || sortableItemsById === void 0 ? void 0 : sortableItemsById.length) > 0 &&
            active &&
            over &&
            handleDragEndCallback) {
            handleDragEndCallback(active.id, over.id);
        }
    }, [sortableItemsById === null || sortableItemsById === void 0 ? void 0 : sortableItemsById.length, handleDragEndCallback]);
    var handleDragStart = React.useCallback(function (_event) {
        if (handleDragStartCallback) {
            handleDragStartCallback();
        }
    }, [handleDragStartCallback]);
    var handleDragCancel = React.useCallback(function (_event) {
        if (handleDragCancelCallback) {
            handleDragCancelCallback();
        }
    }, [handleDragCancelCallback]);
    return (React.createElement(React.Fragment, null,
        React.createElement(DndContext, { sensors: sensors, modifiers: [restrictToVerticalAxis], collisionDetection: closestCenter, onDragStart: handleDragStart, onDragEnd: handleDragEnd, onDragCancel: handleDragCancel, accessibility: {
                announcements: {
                    // set these all to empty strings for now as we don't utilize screen reader instructions for DND
                    // TODO: add screen reader ability to these
                    onDragStart: function () {
                        return '';
                    },
                    onDragMove: function () {
                        return '';
                    },
                    onDragOver: function () {
                        return '';
                    },
                    onDragEnd: function () {
                        return '';
                    },
                    onDragCancel: function () {
                        return '';
                    },
                },
                screenReaderInstructions: {
                    // set to an empty string so we do not announce anything
                    // TODO: add screen reader instructions
                    draggable: '',
                },
            } },
            React.createElement(SortableContext, { items: sortableItemsById, strategy: verticalListSortingStrategy }, children))));
};
export default LazyDnDContext;
//# sourceMappingURL=LazyDnDContext.js.map